import { Directive, EventEmitter, Input, Output } from '@angular/core';
// libs
import { BaseComponent } from '@macs-frontend/core/base';

@Directive()
/* eslint-disable-next-line @angular-eslint/directive-class-suffix */
export abstract class HeaderBaseComponent extends BaseComponent {
  // @ts-expect-error
  @Input() title: string;
  // @ts-expect-error
  @Input() rightButton: string;
  @Output() tappedRight: EventEmitter<boolean> = new EventEmitter();
}
